var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20875 12.75C9.20914 13.6091 8.91452 14.4424 8.37416 15.1103C7.8338 15.7782 7.08048 16.2404 6.24021 16.4194C5.39993 16.5984 4.52366 16.4835 3.75797 16.0938C2.99228 15.7042 2.3836 15.0634 2.03375 14.2788L0.87375 14.7488C1.31167 15.7539 2.06777 16.5874 3.0257 17.1208C3.98363 17.6542 5.0903 17.858 6.17542 17.7009C7.26053 17.5438 8.26395 17.0344 9.03125 16.2512C9.79856 15.468 10.2872 14.4544 10.4221 13.3663C10.5569 12.2782 10.3304 11.1759 9.7775 10.2291C9.22457 9.28233 8.37583 8.54347 7.36189 8.12625C6.34794 7.70903 5.22499 7.63657 4.16584 7.92002C3.10668 8.20347 2.17002 8.82713 1.5 9.69501V8.16626H0.25V11.5L0.875 12.125H3.79125V10.875H2.21C2.6225 10.1595 3.25965 9.60023 4.02255 9.28393C4.78545 8.96764 5.63143 8.91203 6.42917 9.12575C7.22691 9.33947 7.93179 9.81055 8.43439 10.4659C8.93699 11.1212 9.20919 11.9241 9.20875 12.75Z",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0.76163L7.39724 0.25L17.75 7.73727V8.77301L12.2515 12.75V11.2525L16.3926 8.26138L7.65031 1.93464V6.48939H6.5V0.76163Z",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunIcon);
export default __webpack_public_path__ + "static/media/run-icon.ba398f10df7d5f2963de3347b2a10f16.svg";
export { ForwardRef as ReactComponent };